import { Checkbox, Text } from "@chakra-ui/react";
import { Trans } from "@lingui/macro";
import { observer } from "mobx-react-lite";

interface OnlyInvoicedFilterProps {
  checked: boolean;
  onToggle: () => void;
}

const OnlyInvoicedFilter = ({ checked, onToggle }: OnlyInvoicedFilterProps) => {
  return (
    <Checkbox checked={!checked} onChange={() => onToggle()}>
      <Text fontSize="sm">
        <Trans>Show all items</Trans>
      </Text>
    </Checkbox>
  );
};

export default observer(OnlyInvoicedFilter);
